import {
    EVENTBRITE_CATEGORY_TO_REFINEMENT,
    FORMATTED_SUBCATEGORY_MAP,
    SEASONAL_EVENTBRITE_CATEGORY,
} from '@eventbrite/categories';
import { ArrowRightChunky, HolidayCalendar } from '@eventbrite/eds-iconography';
import { getExperiment, logEvent } from '@eventbrite/statsig';
import React, { useEffect, useState } from 'react';
import './Touchpoint.scss';

const STATSIG_CITY_BROWSE_CLICK_NYE_TOUCHPOINT =
    'City Browse - All - Click - NYE Touchpoint';

export const Touchpoint = (props: { currentPlace: string }) => {
    const { currentPlace } = props;
    const ctaLink = `/b/${currentPlace}/${EVENTBRITE_CATEGORY_TO_REFINEMENT[SEASONAL_EVENTBRITE_CATEGORY]}/${FORMATTED_SUBCATEGORY_MAP['EventbriteSubCategory/16009'].refinement}/?utm_source=citybrowse_nye_touchpoint_click`;
    const [showTouchpoint, setShowTouchpoint] = useState(false);

    const handleOnClick = () => {
        logEvent(STATSIG_CITY_BROWSE_CLICK_NYE_TOUCHPOINT);
    };

    useEffect(() => {
        const variant = getExperiment(
            'nye_touchpoint_from_city_browse_page',
            'show_nye_touchpoint',
            'false',
        );
        setShowTouchpoint(variant == 'true');
    }, []);

    return (
        <>
            {showTouchpoint ? (
                <div className="outerDiv">
                    <a
                        data-heap-id="ttd-nye-touchpoint"
                        href={ctaLink}
                        onClick={handleOnClick}
                        className="touchpoint"
                    >
                        <div className="eclipse">
                            <div>
                                <HolidayCalendar
                                    viewBox="0 0 32 32"
                                    className="calendar"
                                />
                            </div>
                        </div>
                        <span className="touchpointText">
                            Explore New Year’s Eve events in {currentPlace}
                        </span>
                        <ArrowRightChunky className="arrowRight" />
                    </a>
                </div>
            ) : null}
        </>
    );
};
